(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Ensure mobile_view param persists on all pagination links */
  document.addEventListener('DOMContentLoaded', () => {
    const isMobile = window.innerWidth <= 749;
    if (isMobile) {
      document.querySelectorAll('.pagination a, .cus-pagination a').forEach(a => {
        try {
          const linkUrl = new URL(a.href, window.location.origin);
          linkUrl.searchParams.set('mobile_view', '1');
          a.href = linkUrl.toString();
        } catch(e) {}
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
